import "./amazonclone.css";
import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import { useState } from "react";

import { Navigation, A11y, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { keyFeaturesData } from "./data";

const Amazonclone = () => {
  // services
  const [isPrevServiceDisabled, setIsPrevServiceDisabled] = useState(true);
  const [isNextServiceDisabled, setIsNextServiceDisabled] = useState(false);

  const handleServiceChange = (ServiceSwiper) => {
    setIsPrevServiceDisabled(ServiceSwiper.isBeginning);
    setIsNextServiceDisabled(ServiceSwiper.isEnd);
  };

  // develop
  const [isPrevDevDisabled, setIsPrevDevDisabled] = useState(true);
  const [isNextDevDisabled, setIsNextDevDisabled] = useState(false);

  const handleDevChange = (DevSwiper) => {
    setIsPrevDevDisabled(DevSwiper.isBeginning);
    setIsNextDevDisabled(DevSwiper.isEnd);
  };

  // features
  const [isPrevFeatureDisabled, setIsPrevFeatureDisabled] = useState(true);
  const [isNextFeatureDisabled, setIsNextFeatureDisabled] = useState(false);

  const handleFeatureChange = (FeatureSwiper) => {
    setIsPrevFeatureDisabled(FeatureSwiper.isBeginning);
    setIsNextFeatureDisabled(FeatureSwiper.isEnd);
  };

  const [activeKeyIndex, setActiveKeyIndex] = useState(0);

  const handleKeyShow = (index) => {
    setActiveKeyIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title> Amazon Clone Powered By AI</title>

        <meta name="title" content=" Amazon Clone Powered By AI " />
        <meta
          name="description"
          content="Build Your ECommerce Giant Like Amazon, With our Amazon clone script solution. Get free consultation from our experts."
        />

        <meta property="og:title" content=" Amazon Clone Powered By AI" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/amazon-clone"
        />
      </Helmet>

      <main className="az-main">
        {/* hero */}
        <article className="az-hero">
          <h1 className="az-hero-title">
            <span className="az-span">Amazon</span> Clone
          </h1>
          <p className="az-hero-content">
            Launch your own Ecommerce empire with our Amazon clone development!
          </p>
          <button
            data-toggle="modal"
            data-target="#myModal"
            className="az-hero-btn"
          >
            Get Free Consultation
            <span className="az-hero-btn-icon">
              <i className="fa fa-arrow-right"></i>
            </span>
          </button>

          <div className="text-center">
            <img
              src={require("../../../image/amazonclone/hero.webp")}
              alt="Amazon Clone"
              loading="lazy"
              className="az-hero-img"
            />
          </div>

          <img
            src={require("../../../image/amazonclone/hero-lft.webp")}
            alt="Amazon Clone"
            loading="lazy"
            className="az-hero-img-lft"
          />
          <img
            src={require("../../../image/amazonclone/hero-rgt.webp")}
            alt="Amazon Clone"
            loading="lazy"
            className="az-hero-img-rgt"
          />
        </article>
        {/* about */}
        <article className="az-about primary__landing__container az-mb-80">
          <div className="row mx-0 az-about-row">
            <div className="col-lg-4">
              <h3 className="az-about-title">
                What Is <span className="az-span">an Amazon Clone?</span>{" "}
              </h3>
            </div>
            <div className="col-lg-8">
              <div className="az-about-content">
                <p>
                  <span>
                    An Amazon clone is a replica of the popular e-commerce
                    marketplace, offering similar functionalities such as
                    product listings, shopping cart integration, secure payment
                    gateways, and vendor management. With an Amazon clone,
                    businesses can launch their own online store and capitalize
                    on the growing demand for digital shopping.
                  </span>
                </p>
              </div>
            </div>
          </div>
          <img
            src={require("../../../image/amazonclone/about.webp")}
            alt="Amazon Clone"
            loading="lazy"
            className="az-about-img"
          />
        </article>
        {/* acd */}
        <article className="az-acd primary__landing-content-container az-mb-100">
          <div className="row mx-0 az-acd-row">
            <div className="col-lg-6">
              <h3 className="az-subtitle">
                Amazon <span className="az-span">Clone Development</span>{" "}
                <p className="az-subcontent mt-3">
                  The e-commerce industry is growing exponentially, with
                  businesses looking for ways to establish their own online
                  marketplaces. One of the most effective ways to achieve this
                  is by developing an Amazon clone, a powerful e-commerce
                  platform with features similar to Amazon. With the right
                  Amazon clone development approach, you can create a robust
                  online marketplace, attract buyers and sellers, and generate
                  significant revenue.
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="az-hero-btn"
                >
                  Get Free Demo
                  <span className="az-hero-btn-icon">
                    <i className="fa fa-arrow-right"></i>
                  </span>
                </button>
              </h3>
            </div>
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/amazonclone/acd.webp")}
                alt="Amazon Clone"
                loading="lazy"
              />
            </div>
          </div>
        </article>
        {/* why choose */}
        <article className="az-why-choose primary__landing-content-container az-mb-80">
          <div className="az-why-choose-top">
            <h3 className="az-why-choose-title">
              Why Choose An <span className="az-span">Amazon Clone? </span>{" "}
            </h3>

            <div className="fd-step-btn-wrap m-0 az-choose-btn-wrap">
              <button
                className={`fd-st-prev-arr ${
                  isPrevServiceDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevServiceDisabled ? "#00000090" : "#000000",
                  cursor: isPrevServiceDisabled ? "not-allowed" : "pointer",
                  background: isPrevServiceDisabled ? "#878787" : "#ffffff",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`fd-st-next-arr ${
                  isNextServiceDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextServiceDisabled ? "#00000090" : "#000000",
                  cursor: isNextServiceDisabled ? "not-allowed" : "pointer",
                  background: isNextServiceDisabled ? "#878787" : "#ffffff",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <div>
            <Swiper
              className="fd-step-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".fd-st-prev-arr",
                nextEl: ".fd-st-next-arr",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleServiceChange}
              onReachBeginning={() => setIsPrevServiceDisabled(true)}
              onReachEnd={() => setIsNextServiceDisabled(true)}
              onFromEdge={() => {
                setIsPrevServiceDisabled(false);
                setIsNextServiceDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="az-choose-cards">
                  <div className="az-card-title-wrap">
                    <h4>Faster Development</h4>
                    <p>
                      No need to build from scratch.{" "}
                      <span className="az-hidden">
                        No need to build from scratch.
                      </span>{" "}
                    </p>
                  </div>
                  <img
                    src={require("../../../image/amazonclone/choose-img-one.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-img"
                  />

                  <img
                    src={require("../../../image/amazonclone/choose-arr.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr"
                  />
                  <img
                    src={require("../../../image/amazonclone/choose-arr-or.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr-or"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-choose-cards">
                  <div className="az-card-title-wrap">
                    <h4>Cost-Effective</h4>
                    <p>
                      {" "}
                      Reduces development costs compared to custom solutions.
                    </p>
                  </div>
                  <img
                    src={require("../../../image/amazonclone/choose-img-two.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-img"
                  />

                  <img
                    src={require("../../../image/amazonclone/choose-arr.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr"
                  />
                  <img
                    src={require("../../../image/amazonclone/choose-arr-or.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr-or"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-choose-cards">
                  <div className="az-card-title-wrap">
                    <h4>Market Ready Features</h4>
                    <p> Includes essential e-commerce functionalities.</p>
                  </div>
                  <img
                    src={require("../../../image/amazonclone/choose-img-three.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-img"
                  />

                  <img
                    src={require("../../../image/amazonclone/choose-arr.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr"
                  />
                  <img
                    src={require("../../../image/amazonclone/choose-arr-or.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr-or"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-choose-cards">
                  <div className="az-card-title-wrap">
                    <h4>Scalability</h4>
                    <p>Can be customized and expanded as needed.</p>
                  </div>
                  <img
                    src={require("../../../image/amazonclone/choose-img-four.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-img"
                  />

                  <img
                    src={require("../../../image/amazonclone/choose-arr.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr"
                  />
                  <img
                    src={require("../../../image/amazonclone/choose-arr-or.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr-or"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-choose-cards">
                  <div className="az-card-title-wrap">
                    <h4>Revenue Generation</h4>
                    <p>
                      Multiple monetization options like commissions and
                      advertisements.
                    </p>
                  </div>
                  <img
                    src={require("../../../image/amazonclone/choose-img-five.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-img"
                  />

                  <img
                    src={require("../../../image/amazonclone/choose-arr.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr"
                  />
                  <img
                    src={require("../../../image/amazonclone/choose-arr-or.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-choose-arr-or"
                  />
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap az-choose-btn-wrap-mob">
              <button
                className={`fd-st-prev-arr ${
                  isPrevServiceDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevServiceDisabled ? "#00000090" : "#000000",
                  cursor: isPrevServiceDisabled ? "not-allowed" : "pointer",
                  background: isPrevServiceDisabled ? "#878787" : "#ffffff",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`fd-st-next-arr ${
                  isNextServiceDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextServiceDisabled ? "#00000090" : "#000000",
                  cursor: isNextServiceDisabled ? "not-allowed" : "pointer",
                  background: isNextServiceDisabled ? "#878787" : "#ffffff",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>
        {/* key features */}
        <article className="primary__landing-content-container az-mb-100">
          <div className="row mx-0 az-key-row">
            <div className="col-lg-5">
              <div className="az-key-left">
                <div className="az-key-top">
                  <h3 className="az-key-title">
                    Key Features of{" "}
                    <span className="az-span"> an Amazon Clone</span>
                  </h3>
                  <p className="az-key-content">
                    To make your Amazon clone competitive, it must include
                    essential e-commerce features. Below are the must-have
                    functionalities
                  </p>
                </div>
                <div className="az-key-img-wrap">
                  <img
                    src={require("../../../image/amazonclone/key.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                    className="az-key-lft-img"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="az-key-right-outer">
                <div className="az-key-right">
                  {keyFeaturesData.map((data, index) => {
                    return (
                      <div
                        key={data.id}
                        className={`az-key-rgt-wrap ${
                          activeKeyIndex === index ? "az-pb" : ""
                        }`}
                      >
                        <div
                          className={`az-key-rgt-top ${
                            activeKeyIndex === index ? "" : "az-mb"
                          }`}
                          onClick={() => handleKeyShow(index)}
                        >
                          <h4
                            className={`az-key-rgt-title ${
                              activeKeyIndex === index ? "az-clr" : ""
                            }`}
                          >
                            {data.title}
                          </h4>
                          <span className="az-key-rgt-arr">
                            {activeKeyIndex === index ? (
                              <i className="fa fa-arrow-right az-op"></i>
                            ) : (
                              <i className="fa fa-arrow-right az-cl"></i>
                            )}
                          </span>
                        </div>

                        {activeKeyIndex === index && (
                          <div className="az-key-rgt-main">
                            <p>{data.description}</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </article>
        {/* cost */}
        <article className="primary__landing-content-container az-mb-100">
          <h3 className="az-subtitle text-center">
            <span className="az-span">Cost of </span>
            Amazon Clone Development
          </h3>
          <p className="az-subcontent text-center">
            The cost of developing an Amazon clone depends on multiple factors,
            including
          </p>

          <div className="row mx-0 az-cost-row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="az-cost-card">
                <div className="az-cost-top">
                  <img
                    src={require("../../../image/amazonclone/sparkle.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <h4 className="az-cost-title">Development Approach</h4>
                  <img
                    src={require("../../../image/amazonclone/sparkle.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                </div>

                <div className="az-cost-main">
                  <h6>$10,000 - $50,000</h6>
                  <span>Custom Development</span>
                </div>
                <div className="az-cost-main mt-3">
                  <h6>$5,000 - $25,000</h6>
                  <span>Ready Made Solutions</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="az-cost-card">
                <div className="az-cost-top">
                  <img
                    src={require("../../../image/amazonclone/sparkle.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <h4 className="az-cost-title">Features & Customization</h4>
                  <img
                    src={require("../../../image/amazonclone/sparkle.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                </div>

                <div className="az-cost-main">
                  <h6>$5,000 - $10,000</h6>
                  <span>Basic Features</span>
                </div>
                <div className="az-cost-main mt-3">
                  <h6>$15,000 - $50,000</h6>
                  <span>Advanced Features</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="az-cost-card">
                <div className="az-cost-top">
                  <img
                    src={require("../../../image/amazonclone/sparkle.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <h4 className="az-cost-title">Technology Stack </h4>
                  <img
                    src={require("../../../image/amazonclone/sparkle.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                </div>

                <div className="az-cost-main">
                  <h6>Open-source platforms</h6>
                  <span>Affordable but less scalable.</span>
                </div>
                <div className="az-cost-main mt-3">
                  <h6>Custom Tech Stack</h6>
                  <span>Higher cost but better performance.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-4">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="az-hero-btn"
            >
              Contact Us
              <span className="az-hero-btn-icon">
                <i className="fa fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </article>
        {/* develop */}
        <article className="az-develop primary__landing-content-container az-mb-80">
          <h3 className="az-subtitle az-dev-title">
            How to Develop <span className="az-span">an Amazon Clone</span>
          </h3>

          <div>
            <Swiper
              className="fd-step-swiper az-dev-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".az-dev-prev-arr",
                nextEl: ".az-dev-next-arr",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleDevChange}
              onReachBeginning={() => setIsPrevDevDisabled(true)}
              onReachEnd={() => setIsNextDevDisabled(true)}
              onFromEdge={() => {
                setIsPrevDevDisabled(false);
                setIsNextDevDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="az-dev-card">
                  <div className="az-dev-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/dev-img-one.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                  </div>
                  <h5>Market Research & Planning</h5>
                  <p>
                    Conduct in-depth research on competitors, target audience,
                    and e-commerce trends to define a clear strategy.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-dev-card">
                  <div className="az-dev-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/dev-img-two.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                  </div>
                  <h5>Choose the Right Technology Stack</h5>
                  <p>
                    Selecting the right tech stack ensures the scalability and
                    performance of your Amazon clone.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-dev-card">
                  <div className="az-dev-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/dev-img-three.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                  </div>
                  <h5>UI/UX Design</h5>
                  <p>
                    A visually appealing and user-friendly interface is critical
                    for customer engagement and conversions.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-dev-card">
                  <div className="az-dev-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/dev-img-four.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                  </div>
                  <h5> Develop Core Features</h5>
                  <p>
                    Build essential e-commerce features such as product catalog,
                    shopping cart, user management, and secure checkout.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-dev-card">
                  <div className="az-dev-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/dev-img-five.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                  </div>
                  <h5>Integrate Payment & Security Features</h5>
                  <p>
                    Ensure secure transactions by integrating SSL encryption,
                    two-factor authentication, and fraud detection tools.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-dev-card">
                  <div className="az-dev-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/dev-img-six.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                  </div>
                  <h5>Testing & Deployment</h5>
                  <p>
                    Conduct rigorous testing to identify bugs and optimize
                    performance before launching your Amazon clone.
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`az-dev-prev-arr ${
                  isPrevDevDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevDevDisabled ? "#ffffff90" : "#ffffff",
                  cursor: isPrevDevDisabled ? "not-allowed" : "pointer",
                  background: isPrevDevDisabled ? "#7C7A79" : "#0F0F0F",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`az-dev-next-arr ${
                  isNextDevDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextDevDisabled ? "#ffffff90" : "#ffffff",
                  cursor: isNextDevDisabled ? "not-allowed" : "pointer",
                  background: isNextDevDisabled ? "#7C7A79" : "#0F0F0F",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>
        {/* features */}
        <article className="az-features primary__landing__container az-mb-80">
          <h3 className="az-subtitle az-fe-title">
            Advanced <span className="az-span">Features to Enhance</span> Your
            Amazon Clone
          </h3>
          <p className="az-fe-cont">
            To take your Amazon clone to the next level, you can incorporate
            advanced features that will set you apart from the competition and
            enhance user experience.
          </p>

          <div className="row">
            <div className="col-lg-6"></div>
          </div>

          <div>
            <Swiper
              className="fd-step-swiper az-dev-swiper"
              spaceBetween={30}
              // slidesPerView={3}
              modules={[Navigation, A11y, Pagination, Autoplay]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".az-fe-prev-arr",
                nextEl: ".az-fe-next-arr",
              }}
              // autoplay={{
              //   delay: 2000,
              //   disableOnInteraction: false,
              // }}
              // centeredSlides={true}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 2.5,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleFeatureChange}
              onReachBeginning={() => setIsPrevFeatureDisabled(true)}
              onReachEnd={() => setIsNextFeatureDisabled(true)}
              onFromEdge={() => {
                setIsPrevFeatureDisabled(false);
                setIsNextFeatureDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="az-fe-card">
                  <div className="az-fe-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/fe-img-one.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                    <h4>AI & ML Integration</h4>
                  </div>
                  <p>
                    Integrating AI and ML into your Amazon clone can provide
                    several benefits, AI can suggest products to users based on
                    their browsing and purchase history. AI-powered chatbots can
                    provide 24/7 customer support, handle inquiries, and resolve
                    issues without human intervention.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-fe-card">
                  <div className="az-fe-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/fe-img-two.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                    <h4>Blockchain for Transparent Transactions</h4>
                  </div>
                  <p>
                    Blockchain technology can help ensure transparent and secure
                    transactions on your Amazon clone. This is especially
                    beneficial if you plan to incorporate cryptocurrency
                    payments (more on that below) or want to ensure authenticity
                    in product listings.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-fe-card">
                  <div className="az-fe-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/fe-img-three.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                    <h4>Cryptocurrency Payments Integration</h4>
                  </div>
                  <p>
                    To stay ahead of the curve, consider integrating
                    cryptocurrency payments. As cryptocurrencies like Bitcoin
                    and Ethereum become more widely accepted, your Amazon clone
                    can tap into the growing market of crypto enthusiasts who
                    prefer to make purchases using digital currencies.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="az-fe-card">
                  <div className="az-fe-img-wrap">
                    <img
                      src={require("../../../image/amazonclone/fe-img-four.webp")}
                      alt="Amazon Clone"
                      loading="lazy"
                    />
                    <h4>Multi Language and Multi Currency Support</h4>
                  </div>
                  <p>
                    For a truly global reach, adding multi-language and
                    multi-currency support to your Amazon clone is crucial. This
                    allows you to cater to customers from different regions and
                    offer a localized shopping experience, increasing conversion
                    rates.
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`az-fe-prev-arr ${
                  isPrevFeatureDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevFeatureDisabled ? "#000000" : "#ffffff",
                  cursor: isPrevFeatureDisabled ? "not-allowed" : "pointer",
                  background: isPrevFeatureDisabled ? "#575757" : "#FF6200",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`az-fe-next-arr ${
                  isNextFeatureDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextFeatureDisabled ? "#000000" : "#ffffff",
                  cursor: isNextFeatureDisabled ? "not-allowed" : "pointer",
                  background: isNextFeatureDisabled ? "#575757" : "#FF6200",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>
        {/* revenue */}
        <article className="az-revenue primary__landing-content-container az-mb-100">
          <div className="row mx-0 az-rev-row">
            <div className="col-lg-7 col-md-6">
              <div className="az-rev-lft">
                <h3 className="az-rev-title">
                  <span className="az-span">Revenue Generation </span>
                  Strategies for Amazon Clone
                </h3>

                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="az-hero-btn mt-4"
                >
                  Contact Us
                  <span className="az-hero-btn-icon">
                    <i className="fa fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
            <div className="col-lg-5 col-md-6">
              <div className="az-rev-card">
                <div className="az-rev-top">
                  <img
                    src={require("../../../image/amazonclone/rev-img-one.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <h5>Commission Based Model</h5>
                </div>
                <p>Earn a commission from every sale made on your platform.</p>
              </div>
              <div className="az-rev-card card-two">
                <div className="az-rev-top">
                  <img
                    src={require("../../../image/amazonclone/rev-img-two.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <h5>Subscription Plans</h5>
                </div>
                <p>
                  Charge vendors a monthly or yearly fee for listing their
                  products.
                </p>
              </div>
              <div className="az-rev-card card-three">
                <div className="az-rev-top">
                  <img
                    src={require("../../../image/amazonclone/rev-img-three.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <h5>Advertising & Promotions</h5>
                </div>
                <p>
                  Allow sellers to run paid advertisements to boost product
                  visibility.
                </p>
              </div>
              <div className="az-rev-card card-four">
                <div className="az-rev-top">
                  <img
                    src={require("../../../image/amazonclone/rev-img-four.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <h5>Dropshipping</h5>
                </div>
                <p>
                  Sell third-party products without maintaining an inventory.
                </p>
              </div>
              <div className="az-rev-card card-five">
                <div className="az-rev-top">
                  <img
                    src={require("../../../image/amazonclone/rev-img-five.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <h5>Membership Programs</h5>
                </div>
                <p>
                  Offer exclusive benefits like free shipping and discounts
                  through membership subscriptions.
                </p>
              </div>
            </div>
          </div>
        </article>
        {/* choose-prof */}
        <article className="primary__landing-content-container az-mb-100">
          <div className="row mx-0 az-ch-pf-row">
            <div className="col-lg-6">
              <h3 className="az-subtitle">
                Why Choose a{" "}
                <span className="az-span">Professional Amazon Clone</span>{" "}
                Development Company?
              </h3>
              <p className="az-subcontent">
                A reputable Amazon clone development company offers expert
                solutions tailored to your business needs. Benefits of hiring a
                professional team include
              </p>

              <div>
                <div className="az-ch-pf-flex">
                  <img
                    src={require("../../../image/amazonclone/cube.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <p>Customizable solutions with advanced features.</p>
                </div>
                <div className="az-ch-pf-flex">
                  <img
                    src={require("../../../image/amazonclone/cube.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <p>Scalable and secure architecture.</p>
                </div>
                <div className="az-ch-pf-flex">
                  <img
                    src={require("../../../image/amazonclone/cube.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <p>24/7 technical support and maintenance.</p>
                </div>
                <div className="az-ch-pf-flex">
                  <img
                    src={require("../../../image/amazonclone/cube.webp")}
                    alt="Amazon Clone"
                    loading="lazy"
                  />
                  <p>Integration of the latest AI and analytics tools.</p>
                </div>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="az-hero-btn"
                >
                  Get Free Demo
                  <span className="az-hero-btn-icon">
                    <i className="fa fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/amazonclone/prof.webp")}
                alt="Amazon Clone"
                loading="lazy"
              />
            </div>
          </div>
        </article>
        {/* Take Away*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Amazon clone development is an excellent opportunity to establish
              a powerful e-commerce marketplace. By integrating essential
              features, choosing the right technology stack, and implementing a
              solid marketing strategy, you can create a successful Amazon clone
              that attracts buyers and sellers worldwide. If you are looking for
              a trusted Amazon clone development partner, contact our expert
              team today and get started on building your e-commerce empire!
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How long does it take to build an Amazon clone?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The time required to build an Amazon clone depends on
                          the complexity of features and customizations, but
                          typically it takes between 3 to 6 months for a fully
                          functional platform.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Can I integrate AI into my Amazon clone?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, AI can be integrated into your Amazon clone for
                          personalized recommendations, dynamic pricing, and
                          intelligent search features, enhancing the user
                          experience.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Is it possible to accept cryptocurrency payments on an
                          Amazon clone?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Absolutely, you can integrate a crypto payment gateway
                          into your Amazon clone, allowing customers to pay
                          using digital currencies like Bitcoin and Ethereum.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          How much does it cost to build an Amazon clone?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The cost to build an Amazon clone varies based on the
                          platform, features, and customizations but typically
                          ranges from $5,000 to $50,000 for a robust, scalable
                          solution.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Amazonclone;
